module.exports = __webpack_public_path__ + "static/media/illustration-domain.245dff89.svg";